import { useMemo } from 'react'

import Rating from '@/molecules/Rating'
import { ProductReview } from '@/ts/Product'

function ReviewsOverview({ reviews, rating }: ReviewsProps) {
  const groupedCount = useMemo(
    () =>
      reviews.reduce(
        (prev, { rating }) =>
          Object.assign(prev, { [rating]: (prev[rating] ?? 0) + 1 }),
        {} as Record<number, number>
      ),
    [reviews]
  )

  const votes = useMemo(
    () => Object.values(groupedCount).reduce((sum, val) => sum + val),
    [groupedCount]
  )

  return (
    <div className="xl:sticky w-full xl:max-w-sm top-[10px] text-sbtviolet-650">
      <div className="flex items-end mb-4 space-x-3">
        <span className="text-4xl font-medium relative bottom-[-6px] ">
          {rating.toPrecision(2)}
        </span>
        <Rating rating={rating} votes={votes} />
      </div>
      {Object.entries(groupedCount)
        .reverse()
        .map(([rating, count]) => (
          <div
            key={rating}
            className="flex items-center justify-between space-x-2"
          >
            <span className="inline-block w-4 text-lg font-medium text-right ">
              {rating}
            </span>
            <div className="relative flex items-center w-full h-2">
              <div className="w-full h-1 rounded-lg bg-sbtviolet-200" />
              <div
                className={`absolute top-0 h-full rounded-lg bg-sbtviolet-600`}
                style={{ width: `${(count / votes) * 100}%` }}
              />
            </div>

            <span className="inline-block w-4 text-sbtviolet-350">{count}</span>
          </div>
        ))}
    </div>
  )
}

interface ReviewsProps {
  reviews: ProductReview[]
  rating: number
  votes: number
}

export default ReviewsOverview
